<template>
  <div>
     <div
        v-if="loader"
        style="
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        padding-top: 25%;
        background-color: rgba(255, 255, 255, 0.31);
      "
    >
      <div class="text-xs-center">
        <v-progress-circular
            :size="70"
            :width="7"
            indeterminate
            color="#ff9233"
            class="text-xs-center my-5"
            large
        ></v-progress-circular>
      </div>
    </div>
    <v-container fluid grid-list-md class="padding_10">
      <v-layout class="index_header table_opacity_8">
        <!-- <v-flex xs12 md6 class="ml-0" justify-space-around>
          <v-autocomplete
            v-model="filters.station"
            :items="local_stations"
            prepend-icon="mdi-database-search"
            placeholder="Search By Station Name"
            :search-input.sync="search_title"
            item-value="id"
            item-text="name"
            clearable
            @change="searchByTitle()"
          ></v-autocomplete>
        </v-flex> -->
        <v-flex xs12 class="text-xs-right" mt-3>
          <v-menu offset-y>
            <v-btn
              slot="activator"
              color="rgb(248 71 6)"
              class="white--text add_notification"
            >
              <router-link to="/create-ecart-booking" class="white--text">
                <v-icon color="#bbbbc6" class="white--text mr-2">edit</v-icon
                >Create Ecart Booking</router-link
              >
            </v-btn>
          </v-menu>
        </v-flex>

      </v-layout>

        <v-dialog
          v-model="delete_model"
          scrollable
          :overlay="false"
          max-width="500px"
          transition="dialog-transition"
          persistent
      >
        <v-card>
          <v-form>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 md12 lg12>
                  <h3>Are you sure you want to delete the Ecart Details?</h3>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small color="primary" @click="confirmDelete">Delete</v-btn>
              <v-btn
                  small
                  color="black"
                  flat
                  type="reset"
                  @click="delete_model = !delete_model"
              >Cancel</v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>

       <v-dialog
          v-model="edit_dialog"
          scrollable
          :overlay="false"
          max-width="500px"
          max-height="800px"
          transition="dialog-transition"
      >
        <v-card>
          <v-form
              @submit.prevent="validateBeforeSubmit('updateEcartBooking')"
              data-vv-scope="updateEcartBooking"
              ref="form"
              v-model="valid"
          >
            <v-card-text>
              <v-card-title primary-title>
                <span class="headline"></span>
              </v-card-title>
              <v-container fluid grid-list-md style="padding: 0 16px 16px 16px">
                <v-layout row wrap>
                   <v-flex xs12>
                    <v-text-field
                        name="Station_name"
                        label="Station Name"
                        v-model="ecart_details_object.station_name"
                        v-validate="'required'"
                        :disabled="read"
                        :error-messages="errors.collect('updateEcartBooking.Station_name')"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                        name="Detail"
                        label="Details"
                        v-model="ecart_details_object.details"
                        v-validate="'required'"
                        :error-messages="errors.collect('updateEcartBooking.Detail')"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                        name="capacity"
                        label="capacity"
                        v-model="ecart_details_object.capacity"
                        v-validate="'required'"
                        :error-messages="errors.collect('updateEcartBooking.capacity')"
                    ></v-text-field>
                  </v-flex>
                   <v-flex xs12>
                    <v-text-field
                        name="fares"
                        label="fares"
                        v-model="ecart_details_object.fares"
                        v-validate="'required'"
                        :error-messages="errors.collect('updateEcartBooking.fares')"
                    ></v-text-field>
                  </v-flex>
                   <v-flex xs12>
                    <v-text-field
                        name="contact"
                        label="contact"
                        type="number"
                        v-model="ecart_details_object.contact"
                        v-validate="'required'"
                        :error-messages="errors.collect('updateEcartBooking.contact')"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small color="primary" type="submit">Submit</v-btn>
              <v-btn small flat @click="edit_dialog = !edit_dialog">Cancel</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>

      <v-data-table
        no-results-text="Loading... Please wait"
        :headers="headers"
        :items=" Ecart_list"
        :pagination.sync="pagination"
        :loading="loaders.Ecart_list_loader"
        :total-items="total_items"
        :rows-per-page-items="[10, 20, 50, 100]"
      >
        <template v-slot:headers="props">
          <tr>
            <th
              style="width: 27%"
              v-for="header in props.headers"
              :key="header.text"
            >
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          
            
          <td>{{ props.item.station_name }}</td>
          <td>{{ props.item.details }}</td>
          <td>{{ props.item.capacity}}</td>
          
          <td>{{ props.item.fares}}</td>
          <td>{{ props.item.contact }}</td>
          <td>{{ (props.item.updated_at) | appDateTimeFormat}}</td>
          <td class='pa-1'>
             <v-layout row>
               <v-btn small color="primary" class="white--text elevation-5" @click="ecartDetails(props.item)">Edit</v-btn>
                <v-btn small color="#F84706" class="white--text elevation-5" @click="ecartDelete(props.item.id)">Delete</v-btn>
            </v-layout>
          </td>
        
        </template>
        <template slot="no-data">
          <v-layout
            row
            wrap
            justify-center
            class="text-xs-center"
            v-if="loaders.Ecart_list_loader"
          >
            Loading... Please wait
          </v-layout>
          <v-layout row wrap justify-center class="text-xs-center" v-else>
            No data available
          </v-layout>
        </template>
      </v-data-table>
       <v-snackbar
          :color="snack_bar.color"
          :top="snack_bar.top"
          :bottom="snack_bar.bottom"
          :left="snack_bar.left"
          :right="snack_bar.right"
          v-model="snack_bar.show"
      >
        {{ snack_bar.message }}
        <v-btn dark flat @click.native="snack_bar.show = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Index",
  data: () => {
    return {
      headers: [
        {
          text: "Station",
          value: "station",
          align: "left",
          sortable: false,
        },
        {
          text: "Details",
          value: "details",
          sortable: false,
        },
        {
          text: "Capacity",
          value: "capacity",
          sortable: false,
        },
        {
          text: "Fares",
          value: "fares",
          sortable: false,
        },
        {
          text: "Contact",
          value: "contact",
          sortable: false,
        },
         {
          text: "Updated_at",
          value: "updated_at",
          sortable: false,
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
        },
      ],
      Ecart_list:[],
      ecart_details_object:{},
      loaders: {
        Ecart_list_loader: false,
      },
      station_ads_inventory_list: [],
      station_inventory_object:{},
      local_stations:[],
      api_type:"web",
      loader: false,
      total_items: 0,
      status: true,
      edit_dialog:false,
      delete_model:false,
        read:true,
        snack_bar: {
        show: false,
        message: "",
        top: true,
        right: true,
        bottom: false,
        left: false,
        color: "",
      },  
      titles: [],
      title_type: [],
      title_list: [],
      title_searched: "",
      search_title: "",
      pagination: { sortBy: "created_at", descending: false, rowsPerPage: 10 },
      filters: {
        station:"",
        title: "",
        Published: false,
        Draft: false,
      },
    };
  },
  watch: {
    pagination: {
      handler() {
        this.getList();
      },
    },
   
    "filters.station": {
      handler(value) {
        if (value == undefined) {
          this.filters.station = "";
          this.getList();
        }
      },
    },
   
   
  },
 methods: {


     ecartDelete: function(ecart_id) {
        this.ecart_details_object.id = ecart_id;
        this.delete_model = true;

     },

   
     confirmDelete: function () {
      this.loader = true;
      axios
          .post(
              `${process.env.VUE_APP_API_URL}/api/v1/delete-ecart-detail`,
              { ecart_id: this.ecart_details_object.id},
              { headers: this.$headers }
          )
          .then((response) => {
            if (response.data.status == 1) {
              this.loader = false;
              this.delete_model = false;
              this.snack_bar.message = response.data.message;
              this.snack_bar.show = true;
              this.getList();
            }
          })
          .catch((error) => {})
          .finally(() => {});
    },

      validateBeforeSubmit: function (scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this[scope]();
        }
      });
    },

     ecartDetails: function(ecartDetail){
      this.ecart_details_object.ecart_id = ecartDetail.id;
      this.ecart_details_object.station_name = ecartDetail.station_name;
      this.ecart_details_object.details = ecartDetail.details;
      this.ecart_details_object.capacity = ecartDetail.capacity;
      this.ecart_details_object.fares = ecartDetail.fares;
      this.ecart_details_object.contact = ecartDetail.contact;
      this.edit_dialog=true;
     },

     updateEcartBooking: function(){
     this.loader =  true; 
     let new_ecart_booking = Object.assign({}, this.ecart_details_object);
     
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/update-ecart-booking`, new_ecart_booking,{ headers: this.$headers }).then((response)=>{
        if(response.data.status == 1)
        {

          this.edit_dialog=false;
          this.loader=false;
          this.snack_bar.message = response.data.message;
          this.snack_bar.show = true;
          this.getList();
          // this.$router.push({name:"StationAdsInventoryList"});  
        }
        else
        {
          this.snackBar.message = response.data.message;
          this.snackBar.show = true;
        }

      }).catch((error)=>{
        console.log(error);
      }).finally(()=>{
        this.loader =  false;
      });  
     },

    getStations: function(){

       axios
            .get(`${process.env.VUE_APP_API_URL}/api/v1/local-station`,{headers:this.$headers})
            .then(response => {
              if (response.data.status == 1)
              { 
              
                this.local_stations = response.data.stations;
                   
             }  
        })
    },

    filter(e) {
      this.filters.Published = false;
      this.filters.Draft = e;

      this.getList();
    },
    filterPublished(e) {
      this.filters.Draft = false;
      this.filters.Published = e;
      this.getList();
    },
    searchByTitle() {
      this.getList();
    },
    getList: function () {
      this.loaders.Ecart_list_loader = true;
      this.pagination.filters = Object.assign({}, this.filters);
      axios
        .get(`${process.env.VUE_APP_API_URL}/api/v1/ecart-details`, {
          headers: this.$headers,
          params: {'params':this.pagination},
        })
        .then((response) => {
          if (response.data.status == 1) {
            this.Ecart_list = response.data.ecart_details;            
            
          }
        })
        .catch((error) => {
          console.log(error);
          this.snack_bar.message = "Error Occured";
          this.snack_bar.show;
        })
        .finally(() => {
          {
            this.loaders.Ecart_list_loader = false;
          }
        });
      this.is_loading = false;
    },
    getTitlesList: function (newVal) {
      this.loaders.notification_list_loader = true;
      axios
        .get(
          `${process.env.VUE_APP_API_URL}/api/v1/notification-filter-title`,
          { headers: this.$headers, params: { searched_title: newVal } }
        )
        .then((response) => {
          if (response.data.status == 1) {
            this.title_list = response.data.titles;
          }
        })
        .catch((error) => {
          console.log(error);
          this.snack_bar.message = "Error Occured";
          this.snack_bar.show;
        })
        .finally(() => {
          {
            this.loaders.notification_list_loader = false;
          }
        });
      this.is_loading = false;
    },
  },
  mounted() {
    this.getList();
    this.getStations();
  },
};
</script>

<style>
.add_notification {
  background: linear-gradient(90deg, #ff5e5c 0%, #ff9233 100%);
}

</style>

